let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5isQY")).then(() => parcelRequire('bvDPM'));